// The ticketing system release shown in the staff and portal sidebars. 2.3.1 (2026-10-23) = the ticket
// conversation redesign, CC tracking, Mass Email and the redesigned notification emails; the desktop
// (Windows/Mac) and phone apps carry the same number.
export const APP_VERSION = "2.3.1";
